import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { getImageUrl } from '../../../config/s3Config';
import './Hvideo.css';

const Hvideo = () => {
    const [selectedVideo, setSelectedVideo] = useState(0);
    const [isPlaying, setIsPlaying] = useState(true);
    const [isSlideshowActive, setIsSlideshowActive] = useState(true);
    const videoRef = useRef(null);
    const slideshowInterval = useRef(null);
    const navigate = useNavigate();

    const videos = [
    {
        id: 0,
        title: "Dr. Shan Bandara Donate 02",
        src: getImageUrl("/images/video/DrShanBandaraDonate02.webm"),
        duration: 150
    },
    {
        id: 1,
            title: "FREE Counselling Program",
            src: getImageUrl("/images/video/FREECounsellingPrograme.webm"),
            duration: 150
        },
        {
            id: 2,
            title: "SDTI Jan AD 5SEC - Derana",
            src: getImageUrl("/images/video/SDTI June AD 5SEC - Hiru.mp4"),
            duration: 5
        },
        {
            id: 3,
            title: "SDTI Ad SEC - Derana",
            src: getImageUrl("/images/video/SDTI Ad SEC - Derana.mp4"),
            duration: 5
        },
        {
            id: 4,
            title: "SDTI AD 5SEC - Hiru",
            src: getImageUrl("/images/video/SDTI  AD 5SEC - Hiru.mp4"),
            duration: 5
        }
    ];

    // Auto-play and slideshow functionality
    useEffect(() => {
        if (isSlideshowActive && isPlaying) {
            startSlideshow();
        } else {
            stopSlideshow();
        }

        return () => {
            stopSlideshow();
        };
    }, [isSlideshowActive, isPlaying, selectedVideo]);

    // Handle video time updates for slideshow
    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const handleTimeUpdate = () => {
            // Check if video is near end (within 0.5 seconds)
            if (video.duration - video.currentTime < 150) {
                nextVideo();
            }
        };

        video.addEventListener('timeupdate', handleTimeUpdate);
        return () => video.removeEventListener('timeupdate', handleTimeUpdate);
    }, [selectedVideo]);

    const startSlideshow = () => {
        stopSlideshow();
        slideshowInterval.current = setInterval(() => {
            nextVideo();
        }, 150000); // 
    };

    const stopSlideshow = () => {
        if (slideshowInterval.current) {
            clearInterval(slideshowInterval.current);
            slideshowInterval.current = null;
        }
    };

    const nextVideo = () => {
        setSelectedVideo((prev) => (prev + 1) % videos.length);
        setIsPlaying(true);
    };

    const handleVideoEnd = () => {
        if (isSlideshowActive) {
            nextVideo();
        } else {
            setIsPlaying(false);
        }
    };

    const currentVideo = videos[selectedVideo];

    const handleViewGallery = () => {
        navigate('/photos');
    };

    return (
        <div className="hvideo-container">
            <div className="video-section">
                <div className="video-player-section">
                    <div className="video-player">
                        <video
                            ref={videoRef}
                            src={currentVideo.src}
                            controls
                            autoPlay={isPlaying}
                            muted={false}
                            onEnded={handleVideoEnd}
                            className="main-video"
                        >
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className="video-actions">
                        <button 
                            className="view-gallery-btn"
                            onClick={handleViewGallery}
                        >
                            <i className="fa fa-images"></i>
                            View Gallery
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Hvideo;